import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { httpRequest, queryClient } from '@hc/utils';
import toast from 'react-hot-toast';
import create from 'zustand';

export const constructDrugData = (data) => {
  const allergiesTableData = data.map((val) => ({
    value: val,
    id: val?.id ?? 0,
    symptoms: val?.symptoms ?? '',
    status: val?.is_active ?? false,
    updated_at: val?.updated_at ?? '',
    created_at: val?.created_at ?? '',
  }));
  return allergiesTableData;
};

export const useSymptoms = create((set, get) => ({
  symptomsMasterData: [],
  symptomsMasterCount: 0,
  symptoms_id: '',
  symptoms: '',
  loading: false,
  error: {
    symptoms: '',
  },

  // ------------- STORE METHODS ------------------
  getAllSymptoms: async (search = '', limit = 10, offset = 0) => {
    try {
      set({ loading: true });
      const { data } = await queryClient.fetchQuery({
        queryKey: ['getAllsymptoms', search, offset],
        queryFn: async () => {
          const response = await httpRequest(
            'get',
            `${envConfig.api_url}/backofficeMaster/symptoms/get/all?search=${search}&limit=${limit}&offset=${offset}`,
            {},
            true
          );
          return response;
        },
        staleTime: Infinity,
      });
      if (data?.status?.code === 200) {
        set(() => ({
          symptomsMasterData:
            Array.isArray(data?.data?.symptom_data) &&
            data?.data?.symptom_data?.length > 0
              ? constructDrugData(data?.data?.symptom_data)
              : [],
          symptomsMasterCount: data?.data?.symptom_count,
        }));
      }
      set(() => ({ loading: false }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          '❌ Some thing went wrong plesae try again!'
      );
    }
  },

  SymptomsStatusUpdate: async (payload) => {
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/symptoms/status/update`,
        payload,
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? 'Symptoms Status Updated Successfully'
        );
      }
      set({ loading: false });
      return data?.status?.code;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
  addEditSymptoms: async () => {
    const { symptoms, symptoms_id: id } = get();
    const type = id ? 'Update' : 'Add';
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/symptoms/upsert`,
        { id: id || '', symptoms },
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? `Symptoms Data ${type} Successfully`
        );
      }
      set({ loading: false });
      return data;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },

  handleChange: (value) => {
    set({ symptoms: value });
  },
  isIamValidToSave: () => {
    const { symptoms, error } = get();
    if (!symptoms) {
      error.symptoms = 'Please enter your Symptoms name';
    } else {
      error.symptoms = '';
      return true;
    }
  },

  initialEditSymptoms: (value) => {
    set({
      symptoms: value.symptoms ?? '',
      symptoms_id: value.id ?? '',
    });
  },

  clearSymptomsData: () => {
    set({
      symptoms: '',
      symptoms_id: '',
    });
  },
}));
